module.exports = __webpack_public_path__ + "img/hourglass_3.e323fcfc.svg";